import { ArrowContainer, PopoverState } from 'react-tiny-popover';

/** Content of manage-favourites */
export const FavPopupContentFavAdded = ({
  childRect,
  popoverRect,
  position,
}: Pick<PopoverState, 'childRect' | 'popoverRect' | 'position'>) => {
  return (
    <ArrowContainer
      position={position}
      childRect={childRect}
      arrowSize={6}
      popoverRect={popoverRect}
      arrowColor="#577CE7"
    >
      <div className="SearchBar-favourites-popover__content">Favourite Added</div>
    </ArrowContainer>
  );
};
